import { componentSizes } from '@/theme/componentSizes';
import { s } from '@/theme/tokens';
import { Box, Skeleton, Surface } from '@/ui/primitives';
import { buildMetricCardGridColumns } from './StatusMetricCardGridLayout';
import type { ReactElement } from 'react';

export const StatusMetricCardsGridSkeletons = ({ count }: { count: number }): ReactElement => (
  <Box
    sx={{
      width: '100%',
      display: 'grid',
      gridTemplateColumns: buildMetricCardGridColumns(),
      gridAutoRows: '1fr',
      columnGap: s('xl'),
      rowGap: s('xl'),
    }}
  >
    {Array.from({ length: count }).map((_, index) => (
      <Surface
        key={`metric-card-skeleton-${index}`}
        padding="lg"
        sx={{
          backgroundColor: 'background.paper',
          height: '100%',
          display: 'flex',
          alignItems: 'stretch',
          minWidth: 0,
          px: { xs: s('md'), xl: s('lg') },
          pt: s('sm'),
          pb: s('md'),
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: s('lg'),
            pt: s('md'),
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Skeleton
              variant="rounded"
              width="50%"
              height={componentSizes.dataGrid.skeletonHeight}
            />
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'minmax(0, 1fr) auto',
              alignItems: 'center',
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: s('sm'),
                minWidth: 0,
              }}
            >
              <Skeleton
                variant="rounded"
                width={92}
                height={componentSizes.dataGrid.skeletonHeight}
              />
            </Box>
            <Box />
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'minmax(0, 1fr) auto',
              alignItems: 'center',
              columnGap: s('lg'),
              minWidth: 0,
              pb: s('xs'),
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: s('sm'),
                minWidth: 0,
              }}
            >
              <Skeleton
                variant="rounded"
                width={82}
                height={componentSizes.dataGrid.skeletonHeight}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                justifySelf: 'end',
                textAlign: 'right',
              }}
            >
              <Skeleton
                variant="rounded"
                width={80}
                height={componentSizes.dataGrid.skeletonHeight}
              />
            </Box>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
            }}
          >
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
        </Box>
      </Surface>
    ))}
  </Box>
);
